module.exports = __webpack_public_path__ + "static/img/case6-bg.1eea1bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case6-bg.jpg
// module id = dVnv
// module chunks = 0